module.exports = __webpack_public_path__ + "static/media/promo.38530528.png";